import React from 'react';
import ShaqvanaData from '~/components/shaqvana/ShaqvanaData';
import AnalyticsProvider from '~/context/common/AnalyticsProvider';
import {
  DeviceContextProvider,
  type OwnProps as DeviceContextProps
} from '~/context/common/DeviceContext';
import {
  StaticContextProvider,
  type OwnProps as StaticContextProps
} from '~/context/common/StaticContext';

export type ShaqvanaProvidersProps = {
  forDeviceContext: DeviceContextProps;
  forStaticContext: StaticContextProps;
};

type OwnProps = React.PropsWithChildren<
  ShaqvanaProvidersProps & {
    eventableProject: string;
    eventableTrack: string;
  }
>;

const ShaqvanaProviders = ({
  children,
  eventableProject,
  eventableTrack,
  forDeviceContext,
  forStaticContext
}: OwnProps) => (
  <StaticContextProvider {...forStaticContext}>
    <AnalyticsProvider projectName={eventableProject} track={eventableTrack}>
      <DeviceContextProvider {...forDeviceContext}>
        <ShaqvanaData />
        {children}
      </DeviceContextProvider>
    </AnalyticsProvider>
  </StaticContextProvider>
);

export default ShaqvanaProviders;
